<!--suppress ALL -->
<template>
  <div>
    <div class="page case-detail__content">
      <div class="padding15 bg-content m-b-24">
        <div class="m-b-24">
          <el-button type="primary" size="small" @click="addVisable" v-if="this.$hasPerm('H001&01')">添加黑名单</el-button>
          <el-button size="small" icon="el-icon-upload" @click="importBlackPhone" v-if="this.$hasPerm('H001&01')">黑名单上传</el-button>
        </div>
        <div class="bg-content padding15">
          <el-form size="small" label-width="50px" ref="searchRef">
            <el-row :gutter="24">
              <el-col :span="6" v-if="this.$partB()">
                <el-form-item label="公司">
                  <el-select v-model="searchReq.companyId" filterable clearable placeholder="请选择" style="width: 100%;">
                    <el-option
                      v-for="item in companyNameList"
                      :key="item.id"
                      :label="item.companyName"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item label="手机号" label-width="85px">
                  <el-input v-model="searchReq.phone" placeholder="请输入查询条件" style="width: 100%;"/>
                </el-form-item>
              </el-col>
              <el-col :span="7" v-if="this.$partB()">
                <el-form-item label="全局黑名单" label-width="140px">
                  <el-select v-model="searchReq.isAll" filterable clearable placeholder="请选择" style="width: 100%;">
                    <el-option label="是" :value="1"/>
                    <el-option label="否" :value="0"/>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4" :offset="0">
                <div class="text right">
                  <el-button type="primary" size="small" plain @click="searchReq.page = 1; getList();"><i class="fa fa-search"></i> 搜索</el-button>
                  <el-button size="small" @click="searchReq.phone = null; searchReq.companyId = null; searchReq.isAll = null">重置</el-button>
                </div>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="padding15 bg-content">
          <el-table size="small" :data="phoneBlacklist.list">
            <el-table-column fixed property="companyName" v-if="this.$partB()" label="公司" align="center"/>
            <el-table-column fixed property="phone"  label="电话" align="center"/>
            <el-table-column fixed property="startTime"  label="黑名单时间起" align="center"/>
            <el-table-column fixed property="endTime"  label="黑名单时间止" align="center"/>
            <el-table-column fixed property="isAll" v-if="this.$partB()" label="全局黑名单" align="center">
              <template slot-scope="scope">
                <span :title="scope.row.isAll" v-if="scope.row.isAll === true" style="color: #67C23A;">是</span>
                <span :title="scope.row.isAll" v-else>否</span>
              </template>
            </el-table-column>
            <el-table-column fixed property="userName"  label="添加人" align="center"/>
            <el-table-column fixed property="createTime"  label="添加时间"  align="center"/>
            <el-table-column fixed label="操作"  v-if="this.$hasPerm('H001&02')" align="center">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="updateVisiable(scope.row)"><i class="el-icon-edit-outline"></i>&nbsp;编辑</el-button>
                <el-button type="text" size="small" @click="remove(scope.row.id)"><i class="el-icon-delete"></i>&nbsp;删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="text center margin15-tb">
            <el-pagination
              background
              layout="prev, pager, next, sizes, total"
              :total="phoneBlacklist.totalRecords"
              :page-size="searchReq.limit"
              :current-page="searchReq.page"
              @current-change="currentChange"
              @size-change="sizeChange">
            </el-pagination>
          </div>
        </div>
        <!-- 添加黑名单 -->
        <el-dialog title="添加黑名单" :visible.sync="addVisible" width="30%" center>
          <div>
            <el-form size="small" label-width="140px">
              <el-form-item label="公司名称" v-if="this.$partB()">
                <el-select v-model="addReq.companyIds" filterable multiple collapse-tags  placeholder="请选择" style="width: 80%;">
                  <el-option label="全部" :value="-1"></el-option>
                  <el-option
                    v-for="item in companyNameList"
                    :key="item.id"
                    :label="item.companyName"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="电话号码">
                <el-input placeholder="请输入电话号码" v-model="addReq.phone" style="width: 80%;"/>
              </el-form-item>
              <el-form-item label="拉黑时间起">
                <el-date-picker style="width: 80%;"
                  v-model="addReq.startTime"
                  type="datetime"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="拉黑时间止">
                <el-date-picker style="width: 80%;"
                  v-model="addReq.endTime"
                  type="datetime"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="投诉原因">
                <el-input placeholder="请输入内容" type="textarea" v-model="addReq.remark" style="width: 80%;" :rows="4" :maxlength="32" show-word-limit resize="none"/>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="addVisible = false" size="small">取 消</el-button>
            <el-button type="primary" size="small" @click="insert">保存</el-button>
          </div>
        </el-dialog>
        <!-- 编辑黑名单 -->
        <el-dialog title="编辑黑名单" :visible.sync="updateVisible" width="30%" center>
          <div>
            <el-form size="small" label-width="140px">
              <el-form-item label="公司名称" v-if="this.$partB()">
                <el-select v-model="updateReq.companyId" filterable  placeholder="请选择" style="width: 80%;">
                  <el-option label="全部" :value="-1"></el-option>
                  <el-option
                    v-for="item in companyNameList"
                    :key="item.id"
                    :label="item.companyName"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="电话号码">
                <el-input placeholder="请输入电话号码" v-model="updateReq.phone" style="width: 80%;"/>
              </el-form-item>
              <el-form-item label="拉黑时间起">
                <el-date-picker style="width: 80%;"
                  v-model="updateReq.startTime"
                  type="datetime"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="拉黑时间止">
                <el-date-picker style="width: 80%;"
                  v-model="updateReq.endTime"
                  type="datetime"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="投诉原因">
                <el-input placeholder="请输入内容" type="textarea" v-model="updateReq.remark" style="width: 80%;" :rows="4" :maxlength="32" show-word-limit resize="none"/>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="updateVisible = false" size="small">取 消</el-button>
            <el-button type="primary" size="small" @click="update">保存</el-button>
          </div>
        </el-dialog>
        <!-- 黑名单上传 -->
        <el-dialog title="黑名单上传" :visible.sync="importVisible" width="30%" center>
          <div>
            <el-form size="small" label-width="140px">
              <el-form-item label="公司名称" v-if="this.$partB()">
                <el-select v-model="upload.companyIds" filterable multiple collapse-tags  placeholder="请选择" style="width: 80%;">
                  <el-option label="全部" :value="-1"></el-option>
                  <el-option
                    v-for="item in companyNameList"
                    :key="item.id"
                    :label="item.companyName"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="黑名单文件">
                <el-upload class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/"
                  :on-preview="handlePreview"
                  :on-remove="handleRemove"
                  :before-remove="beforeRemove"
                  multiple
                  :limit="1"
                  :auto-upload="false"
                  :on-exceed="handleExceed"
                  :file-list="fileList"
                  :on-change="fileChanged">
                  <el-button size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
                </el-upload>
              </el-form-item>
              <el-form-item label="拉黑时间起">
                <el-date-picker style="width: 80%;"
                  v-model="upload.startTime"
                  type="datetime"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="拉黑时间止">
                <el-date-picker style="width: 80%;"
                  v-model="upload.endTime"
                  type="datetime"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间">
                </el-date-picker>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button icon="el-icon-download" size="small"><a href="/static/template/importBlackPhoneTemplate.xlsx" download style="color: inherit; text-decoration: none;">模板下载</a></el-button>
            <el-button type="primary" size="small" @click="importPhoneBlack">保 存</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      searchReq: {
        companyId: null,
        phone: null,
        isAll: null,
        page: 1,
        limit: 10,
        order: 'rpb.create_time',
        sort: 'desc'
      },
      phoneBlacklist: { 'totalRecords': 0, list: [] },
      companyNameList: [],
      addReq: {
        id: null,
        companyIds: [],
        phone: null,
        startTime: null,
        endTime: null,
        remark: null,
        isAll: false
      },
      updateReq: {
        id: null,
        companyId: null,
        phone: null,
        startTime: null,
        endTime: null,
        remark: null,
        isAll: false
      },
      addVisible: false,
      updateVisible: false,
      importVisible: false,
      fileList: [],
      upload: {
        companyIds: [],
        startTime: null,
        endTime: null
      }
    };
  },
  methods: {
    addVisable() {
      this.addReq.id = null;
      this.addReq.companyIds = [];
      this.addReq.phone = null;
      this.addReq.startTime = null;
      this.addReq.endTime = null;
      this.addReq.remark = null;
      this.addReq.isAll = false;
      this.addVisible = true;
    },
    importBlackPhone() {
      this.fileList = [];
      this.upload.companyIds = [];
      this.upload.startTime = null;
      this.upload.endTime = null;
      this.addReq.isAll = false;
      this.importVisible = true;
    },
    insert() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      if (this.addReq.companyIds.includes(-1)) {
        this.addReq.isAll = true;
      } else {
        this.addReq.isAll = false;
      }
      this.$ajax({
        prompt: true,
        method: 'POST',
        url: '/phoneBlacklist/insert',
        data: this.addReq
      }).then(() => {
        loading.close();
        this.getList();
        this.addVisible = false;
      }).catch(() => {
        loading.close();
      });
    },
    updateVisiable(row) {
      this.updateReq.id = row.id;
      this.updateReq.companyId = row.companyId;
      this.updateReq.phone = row.phone;
      this.updateReq.startTime = row.startTime;
      this.updateReq.endTime = row.endTime;
      this.updateReq.remark = row.remark;
      this.updateReq.isAll = row.isAll;
      if (row.isAll) {
        this.updateReq.companyId = -1;
      }
      this.updateVisible = true;
    },
    update() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      if (this.updateReq.companyId === -1) {
        this.updateReq.isAll = true;
      } else {
        this.updateReq.isAll = false;
      }
      this.$ajax({
        prompt: true,
        method: 'POST',
        url: '/phoneBlacklist/update',
        data: this.updateReq
      }).then(() => {
        loading.close();
        this.getList();
        this.updateVisible = false;
      }).catch(() => {
        loading.close();
      });
    },
    remove(userId) {
      this.$confirm('您确定要删除该黑名单吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          prompt: true,
          method: 'DELETE',
          url: `/phoneBlacklist/remove/${userId}`
        }).then(() => {
          // 刷新
          this.getList();
        });
      });
    },
    getList() {
      this.$ajax({
        method: 'POST',
        url: '/phoneBlacklist/list',
        data: this.searchReq
      }).then((res) => {
        this.phoneBlacklist.list = res.data.list;
        this.phoneBlacklist.totalRecords = res.data.totalRecords;
      });
    },
    currentChange(page) {
      this.searchReq.page = page;
      this.getList();
    },
    // 显示条数
    sizeChange(num) {
      this.searchReq.limit = num;
      this.getList();
    },
    companyList() {
      this.$ajax({
        method: 'GET',
        url: '/company/list'
      }).then((res) => {
        this.companyNameList = res.data;
      });
    },
    handleRemove(file, fileList) {
      console.warn(file, fileList);
    },
    beforeRemove() {
      this.fileList = [];
    },
    handleExceed(files, fileList) {
      console.warn(fileList);
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length} 个文件`);
    },
    fileChanged(files, fileList) {
      if (files.size > (5 * 1024 * 1024)) {
        this.$message.warning('文件大小超出5M,请重新选择！');
        this.fileList = [];
        return;
      }
      this.fileList = fileList;
    },
    handlePreview(file) {
      console.warn(file);
    },
    importPhoneBlack() {
      if (this.fileList.length === 0) {
        this.$message({
          type: 'error',
          message: '上传文件不能为空!'
        });
        return;
      }
      const formData = new FormData();
      if (this.upload.companyIds.includes(-1)) {
        formData.append('isAll', true);
      } else {
        formData.append('isAll', false);
      }
      formData.append('file', this.fileList[0].raw);
      formData.append('companyIds', this.upload.companyIds);
      if (this.upload.startTime === null) {
        this.$message({
          type: 'error',
          message: '拉黑时间起不能为空!'
        });
        return;
      }
      formData.append('startTime', this.upload.startTime);
      if (this.upload.endTime === null) {
        this.$message({
          type: 'error',
          message: '拉黑时间止不能为空!'
        });
        return;
      }
      formData.append('endTime', this.upload.endTime);
      this.$ajax({
        url: '/phoneBlacklist/importPhoneBlack',
        contentType: 'multipart/form-data',
        data: formData
      }).then((res) => {
        if (res.data !== null) {
          this.$notify({
            title: '提示',
            message: res.data,
            duration: 0
          });
        }
        this.importVisible = false;
        this.getList();
      }).catch((error) => {
        this.$message({
          type: 'error',
          message: error.message
        });
      });
    }
  },
  mounted() {
    this.getList();
    this.companyList();
  }
};
</script>



// WEBPACK FOOTER //
// src/page/main/phoneBlacklist/list.vue